import { Label } from '@/components/ui/label';
import { SegmentedToggle, type SegmentedToggleOption } from '@/components/ui/segmented-toggle';
import type { StoreAggregationMode } from '@/lib/types/feature/analysis-data-extraction';

interface StoreGranularitySelectProps {
  value: StoreAggregationMode;
  onValueChange: (mode: StoreAggregationMode) => void;
  /** ラベルの id を一意にするための接頭辞（同一画面に複数配置するため） */
  idPrefix: string;
  disabled?: boolean;
}

const OPTIONS: readonly [
  SegmentedToggleOption<StoreAggregationMode>,
  SegmentedToggleOption<StoreAggregationMode>,
] = [
  { value: 'by_seller', label: '店舗別' },
  { value: 'by_group', label: '店舗グループ別' },
];

/**
 * 店舗軸の出力粒度（店舗別 / 店舗グループ別）の切り替えUI（FKV3-12856 / FKV3-12857）
 *
 * 丸め込む単位は下のツリーで選んだ店舗グループそのものが決めるため、
 * ここでは階層の指定を持たない（FKV3-12858 で「第N階層」の指定を廃止した。
 * 枝ごとに階層数が違うアカウントでは、同じ第N階層でも行の意味が変わってしまうため）。
 *
 * 直後のツリーの見た目が切り替わるため、ツリーの直前に置く（FKV3-13085）。
 */
export function StoreGranularitySelect({
  value,
  onValueChange,
  idPrefix,
  disabled = false,
}: StoreGranularitySelectProps) {
  return (
    <div className="space-y-2">
      <Label id={`${idPrefix}-label`}>出力粒度</Label>
      <div>
        <SegmentedToggle
          value={value}
          onValueChange={onValueChange}
          options={OPTIONS}
          labelledBy={`${idPrefix}-label`}
          disabled={disabled}
        />
      </div>

      <p className="text-sm text-gray-500">
        {value === 'by_group'
          ? '下で選んだ店舗グループごとに1行を出力します。'
          : '店舗ごとに1行を出力します。店舗数が多いアカウントでは行数・ファイルサイズが大きくなります。'}
      </p>
    </div>
  );
}
